"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColumnGroupsLayout = exports.StyledColumnGroupsLayoutColumn = exports.StyledColumnGroupsLayoutGroupOptions = exports.StyledColumnGroupsLayoutHeaderGroup = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
exports.StyledColumnGroupsLayoutHeaderGroup = (0, styled_components_1.default)(Text_1.Text) `
    font-weight: 600;
    line-height: ${helpers_1.SPACING_XL};
`;
exports.StyledColumnGroupsLayoutGroupOptions = styled_components_1.default.div ``;
exports.StyledColumnGroupsLayoutColumn = styled_components_1.default.div ``;
exports.StyledColumnGroupsLayout = (0, styled_components_1.default)(StackView_1.StackView) `
    ${exports.StyledColumnGroupsLayoutGroupOptions} + ${exports.StyledColumnGroupsLayoutGroupOptions} {
        border-top: ${helpers_1.BASE_BORDER_WIDTH} solid ${({ theme }) => theme.colorBorderMain};
        margin-top: ${helpers_1.SPACING_S};
        padding-top: ${helpers_1.SPACING_M};
    }
`;
//# sourceMappingURL=ColumnGroupsLayout.styles.js.map